import { ErrorBoundary } from "@sentry/react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "../../assets/styles/component/menu.scss";
import { CXO_DASHBOARD_URL } from "../../constants";
import { ThemeContext } from "../../context";
import MenuItems from "./MenuItems/MenuItems";
import { closeAllChildElements } from "./subs/menuFunctions";

export const DashboardMenu = withRouter((props: RouteComponentProps) => {
  const { theme } = useContext(ThemeContext);

  const { history, location } = props;
  const cxoToken = useSelector((state: RootStateOrAny) => state.user.cxoToken.token);
  const userDetails = useSelector((state: RootStateOrAny) => state.user.details);
  const [cxoUrl, setCxoUrl] = useState(CXO_DASHBOARD_URL);

  const [mobileMenuExpanded, setMobileMenuExpanded] = useState(false);

  const expandedClassName = "expanded";

  useEffect(() => {
    setCxoUrl(`${CXO_DASHBOARD_URL}${cxoToken}`);
  }, [cxoToken]);

  useEffect(() => {
    const headerElement = document.getElementById("header_wrapper");
    const ulElement = document.getElementById("profile");
    if (mobileMenuExpanded) {
      headerElement?.classList.add(expandedClassName);
      ulElement?.classList.add(expandedClassName);
    } else {
      headerElement?.classList.remove(expandedClassName);
      ulElement?.classList.remove(expandedClassName);
    }
  }, [mobileMenuExpanded]);

  const onBurgerMenuClick = useCallback(() => setMobileMenuExpanded(true), [setMobileMenuExpanded]);

  const onCloseMenuClick = useCallback(() => {
    closeAllChildElements();
    setMobileMenuExpanded(false);
  }, [setMobileMenuExpanded]);

  const homeRedirect = useCallback(
    (evt: React.MouseEvent<HTMLElement>) => {
      evt.stopPropagation();

      const pageLink = "/home";

      history.push({ pathname: pageLink, search: "" });
      window.location.reload();
    },
    [history]
  );

  return (
    <ErrorBoundary>
      <header id="oce_header">
        <div id={"header_wrapper"} className="main_header" onMouseLeave={closeAllChildElements}>
          <MenuItems
            onClickCloseMenuHandler={onCloseMenuClick}
            activePage={location?.pathname}
            firstName={userDetails?.first_name}
            lastName={userDetails?.last_name}
            email={userDetails?.email}
            cxoUrl={cxoUrl}
            onBurgerMenuClick={onBurgerMenuClick}
          />
        </div>
      </header>
    </ErrorBoundary>
  );
});
